/* eslint-env node, browser */
'use strict'

/**
 * prevents default for this event
 *
 * @param {Event} e
 * @returns void
 */
module.exports = function (e) {
  if (e.preventDefault) {
    e.preventDefault()
    return
  }

  e.returnValue = false
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/combokeys/helpers/preventDefault.js
// module id = 1547
// module chunks = 2